// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,

  PDF:`https://uatskexam.s3.amazonaws.com/public/result/`,
  SERVER_URL: "https://uat-scholarquest-api.hubblehox.com/v1/",
  // TEST_REDIRECT_URL: "https://hubblestar-uat.hubblehox.ai/#/assessmentLanding",
  // TEST_REDIRECT_URL: "https://smart-staff-selection-dev.web.app/#/staticassessment",
  // TEST_REDIRECT_URL: "https://hubblestar-stag.hubblehox.ai/#/assessmentLanding",
  TEST_REDIRECT_URL: "https://hubblestar-uat.hubblehox.ai/#/assessmentLanding", // UAT URL
  MOCK_TEST_PAYMENT_REDIRECT_URL: `https://uat-scholarquest-api.hubblehox.com/v1/users/captureTestPayment?redirect=https://uat-scholarquest.hubblehox.com/student/payment-status`,
  MOCK_TEST_INSTITUTE_PAYMENT_REDIRECT_URL: `https://uat-scholarquest-api.hubblehox.com/v1/users/captureTestPayment?redirect=https://uat-scholarquest.hubblehox.com/institute/teacher-assessments/payment-status`,
  // //LOCAL URL END

  keycloak: {
    url: 'https://sso.ampersandgroup.in/',
    realm: 'ampersand-external-dev',
    clientId: 'osehub-scholarquest-uat',
  },
  MAIN_PLATFORM_URL: 'https://uat.osehub.com/profile/booking/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
